import http from "./http";
import {useRequest} from "ahooks";
import {config} from "../utils";
import cookies from "../utils/cookies";

let apiPath = {
  upload: '/file/fileInfo/upload',
};

export const useImgUpload = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {

    
    return http({
      url: apiPath.upload,
      method: 'post',
      data: q,
    }, { noAlias: true,formdata: true });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    uploadHandle: runAsync
  };
};
